import General from "general/index";
import Mod from "module/index";

export default [...General, ...Mod];
